import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

/* External Components */

/* Routing Provider */
import { SubjectRoutingProvider } from './subject.routes';

import { SubjectListingComponent } from "./subjects-listing.component";

@NgModule({
    imports: [
        BrowserModule, FormsModule, HttpModule,
        BrowserAnimationsModule,
        SubjectRoutingProvider
    ],
    
    // module dependencies
    declarations: [
        SubjectListingComponent
    ],
    providers: [],
    exports: [SubjectListingComponent]
})
export class SubjectModule { }
